"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M5 5L19 19", stroke: "currentColor", strokeWidth: "1.5" }),
    react_1.default.createElement("path", { d: "M5 19L19 5", stroke: "currentColor", strokeWidth: "1.5" })));
